export const it = {
  // Navigation
  home: "Home",
  about: "Chi Siamo",
  tours: "Tour",
  deals: "Offerte",
  testimonials: "Testimonianze",
  blog: "Blog",
  contact: "Contatti",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "Benvenuti in Sri Lanka",
  welcomeSubtitle: "Scopri la bellezza della perla dell'Oceano Indiano",
  exploreButton: "Esplora i Tour",
  learnMoreButton: "Scopri di Più",
  
  // About page
  aboutTitle: "Chi Siamo",
  aboutSubtitle: "Il tuo partner di viaggio di fiducia in Sri Lanka",
  aboutDescription: "Ci specializziamo nella creazione di esperienze di viaggio indimenticabili in tutto lo Sri Lanka, dalle spiagge incontaminate agli antichi templi.",
  
  // Tours page
  toursTitle: "I Nostri Tour",
  toursSubtitle: "Scopri destinazioni incredibili",
  bookNow: "Prenota Ora",
  viewDetails: "Vedi Dettagli",
  
  // Contact page
  contactTitle: "Contattaci",
  contactSubtitle: "Mettiti in contatto con noi",
  name: "Nome",
  email: "Email",
  message: "Messaggio",
  send: "Invia Messaggio",
  phone: "Telefono",
  address: "Indirizzo",
  
  // Testimonials
  testimonialsTitle: "Cosa Dicono i Nostri Clienti",
  testimonialsSubtitle: "Esperienze reali di viaggiatori reali",
  
  // Blog
  blogTitle: "Blog di Viaggio",
  blogSubtitle: "Ultime storie di viaggio e consigli",
  readMore: "Leggi di Più",
  
  // Common
  loading: "Caricamento...",
  error: "Si è verificato un errore",
  success: "Successo!",
  close: "Chiudi",
  submit: "Invia",
  cancel: "Annulla",
  
  // Language selector
  selectLanguage: "Seleziona Lingua",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  
  // About Us Page
  whyChooseTitle: "Perché Scegliere Sri Yatra Viaggi?",
  whyChooseSubtitle: "Ci impegniamo a fornirti le migliori esperienze di viaggio con servizi eccezionali e pacchetti personalizzati.",
  personalizedTitle: "Pianificazione Viaggi Personalizzata",
  personalizedDesc: "Adattiamo ogni viaggio alle tue esigenze uniche, garantendo un'esperienza di viaggio unica nel suo genere.",
  customerSupportTitle: "Supporto Clienti 24/7",
  customerSupportDesc: "I nostri esperti di viaggio dedicati sono disponibili 24 ore su 24 per assisterti con qualsiasi domanda.",
  destinationsTitle: "Destinazioni Selezionate",
  destinationsDesc: "Esplora le migliori destinazioni accuratamente selezionate per offrirti esperienze indimenticabili.",
  priceGuaranteeTitle: "Garanzia Miglior Prezzo",
  priceGuaranteeDesc: "Offriamo prezzi competitivi senza compromettere la qualità della tua esperienza di viaggio.",
  luxuryTitle: "Lusso e Comfort",
  luxuryDesc: "Goditi sistemazioni di lusso e arrangiamenti di viaggio senza problemi per il massimo comfort.",
  guidesTitle: "Guide Turistiche Esperte",
  guidesDesc: "Le nostre guide competenti e amichevoli assicurano che tu tragga il massimo dal tuo viaggio.",
  
  // Contact Page
  getInTouchTitle: "Mettiti in Contatto con Sri Yatra Viaggi",
  loveToHearTitle: "Ci Piacerebbe Sentire da Te",
  loveToHearDesc: "Che tu abbia una domanda sui nostri tour, sui prezzi o su qualsiasi altra cosa, il nostro team è pronto a rispondere a tutte le tue domande.",
  office: "Ufficio",
  phone: "Telefono",
  support: "Supporto",
  email: "Email",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "Inviaci un Messaggio",
  contactFormDesc: "Compila il modulo qui sotto e ti risponderemo il prima possibile.",
  namePlaceholder: "Il Tuo Nome",
  emailPlaceholder: "La Tua Email",
  phonePlaceholder: "Il Tuo Numero di Telefono",
  messagePlaceholder: "Il Tuo Messaggio",
  submitButton: "Invia Messaggio",
  submitting: "Invio in corso...",
  messageSent: "Messaggio inviato con successo!",
  messageError: "Impossibile inviare il messaggio. Riprova.",
  
  // Testimonials Page
  customerReviewsTitle: "Cosa Dicono i Nostri Clienti",
  customerReviewsSubtitle: "Esperienze reali di viaggiatori reali che hanno esplorato lo Sri Lanka con noi",
  
  // Blog Page
  travelBlogTitle: "Blog di Viaggio",
  travelBlogSubtitle: "Ultime storie di viaggio, consigli e approfondimenti dalle nostre avventure in Sri Lanka",
  
  // Tours Page
  ourToursTitle: "I Nostri Tour",
  ourToursSubtitle: "Scopri destinazioni incredibili ed esperienze indimenticabili",
  
  // Deals Page
  specialDealsTitle: "Offerte Speciali",
  specialDealsSubtitle: "Offerte esclusive e sconti sui nostri migliori tour",
  
  // Tour Content
  culturalTourTitle: "Tour Culturale dello Sri Lanka",
  culturalTourDesc: "Vivi il ricco patrimonio e i siti storici dello Sri Lanka in questo tour culturale.",
  wildlifeTourTitle: "Avventura Safari Faunistico",
  wildlifeTourDesc: "Esplora i famosi parchi faunistici dello Sri Lanka e osserva animali esotici nel loro habitat naturale.",
  beachTourTitle: "Vacanza al Mare",
  beachTourDesc: "Rilassati sulle spiagge più belle dello Sri Lanka con acque cristalline e sabbia dorata.",
  hillCountryTourTitle: "Avventura nelle Colline",
  hillCountryTourDesc: "Scopri la bellezza panoramica delle montagne, cascate e piantagioni di tè dello Sri Lanka.",
  honeymoonTourTitle: "Pacchetto Luna di Miele di Lusso",
  honeymoonTourDesc: "Goditi un'esperienza romantica e lussuosa di luna di miele nei migliori resort dello Sri Lanka.",
  adventureTourTitle: "Tour Avventura e Trekking",
  adventureTourDesc: "Intraprendi emozionanti avventure di trekking e attività all'aperto nello Sri Lanka.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "Pacchetto Luna di Miele Esclusivo dello Sri Lanka",
  exclusiveHoneymoonDesc: "Goditi una luna di miele lussuosa con fughe romantiche, resort balneari ed esperienze culturali.",
  adventureWildlifeTitle: "Tour Avventura e Fauna Selvatica",
  adventureWildlifeDesc: "Esplora la natura selvaggia dello Sri Lanka con safari emozionanti ed escursioni naturalistiche.",
  luxuryBeachTitle: "Vacanza di Lusso al Mare",
  luxuryBeachDesc: "Rilassati sulle spiagge più belle, goditi gli sport acquatici e vivi un'ospitalità di prima classe.",
  culturalHeritageTitle: "Tour del Patrimonio Culturale",
  culturalHeritageDesc: "Visita i siti del patrimonio UNESCO, antichi templi e città vibranti dello Sri Lanka.",
  budgetFamilyTitle: "Vacanza Famiglia Economica",
  budgetFamilyDesc: "Un pacchetto economico e family-friendly con attività emozionanti per tutte le età.",
  ultimateAdventureTitle: "Tour Avventura Definitivo",
  ultimateAdventureDesc: "Trekking, rafting e sport avventura nei paesaggi mozzafiato dello Sri Lanka.",
  
  // Blog Content
  exploringBeautyTitle: "Esplorando la Bellezza dello Sri Lanka",
  exploringBeautyExcerpt: "Scopri i paesaggi mozzafiato, la ricca storia e le meraviglie culturali dello Sri Lanka in questa guida di viaggio completa.",
  bestBeachesTitle: "Le Migliori Spiagge dello Sri Lanka",
  bestBeachesExcerpt: "Dalle spiagge di sabbia dorata alle acque turchesi mozzafiato, esplora le migliori destinazioni balneari dello Sri Lanka per una fuga perfetta.",
  wildlifeSafariTitle: "Avventure Safari Faunistico",
  wildlifeSafariExcerpt: "Vivi l'emozione di avvistare elefanti, leopardi e uccelli esotici nei rinomati parchi nazionali dello Sri Lanka.",
  
  // Testimonial Content
  johnReview: "Il nostro viaggio in Sri Lanka è stato assolutamente fantastico! La pianificazione e l'organizzazione sono state perfette, e ci siamo sentiti ben curati durante tutto il viaggio. Consiglio vivamente Sri Yatra Travels!",
  emmaReview: "Un'esperienza davvero memorabile! Dalle bellissime spiagge ai siti culturali mozzafiato, tutto è stato perfettamente pianificato. Non vedo l'ora di tornare!",
  carlosReview: "La migliore agenzia di viaggi con cui ho mai prenotato! Tutto è stato ben organizzato e le guide erano competenti e amichevoli. Grazie per un'esperienza incredibile!",
  sophiaReview: "Un viaggio senza problemi e indimenticabile! Il team è stato professionale e l'itinerario ben pensato. Consiglio vivamente Sri Yatra Travels a chiunque visiti lo Sri Lanka.",
  
  // Common Labels
  activities: "Attività",
  duration: "Durata",
  price: "Prezzo",
  workingHours: "Orari di Lavoro",
  workingHoursText: "Lunedì – Venerdì: 9:00 AM – 6:00 PM",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "Highlights dello Sri Lanka",
  fiveDayHighlightsSubtitle: "Highlights: Katunayake, Sigiriya, Kandy, Ella, Galle. Un viaggio compatto attraverso le destinazioni imperdibili dello Sri Lanka.",
  bookNow: "Prenota Ora",
  
  // Katunayake
  day1Title: "Arrivo",
  katunayakeTitle: "Katunayake",
  katunayakeStay: "Soggiorno confortevole vicino a Katunayake",
  katunayakeActivities: "Attività",
  katunayakeArrival: "Arrivo all'Aeroporto Internazionale Bandaranaike",
  katunayakeMeetGreet: "Incontro e trasferimento al soggiorno nelle vicinanze",
  katunayakeNegombo: "Visita opzionale alla spiaggia di Negombo (se il tempo lo permette)",
  katunayakeRest: "Riposo e recupero dal volo",
  katunayakeLocation: "Katunayake - Aeroporto Internazionale Bandaranaike",
  katunayakeDescription: "Inizia i tuoi highlights dello Sri Lanka con una comoda prima notte vicino all'aeroporto.",
  
  // Sigiriya
  day2Title: "Sigiriya",
  sigiriyaTitle: "Sigiriya",
  sigiriyaStay: "Guesthouse a Sigiriya",
  sigiriyaTransfer: "Trasferimento a Sigiriya",
  sigiriyaClimb: "Scalata della Fortezza Rocciosa di Sigiriya",
  sigiriyaExplore: "Esplorazione dei giardini acquatici e degli affreschi",
  sigiriyaVillage: "Esperienza del villaggio o giro in bicicletta (opzionale)",
  sigiriyaLocation: "Fortezza Rocciosa di Sigiriya",
  sigiriyaDescription: "Iconico sito del Patrimonio Mondiale UNESCO con viste panoramiche.",
  
  // Kandy
  day3Title: "Kandy",
  kandyTitle: "Kandy",
  kandyStay: "Hotel a Kandy",
  kandyTransfer: "Trasferimento a Kandy",
  kandyTemple: "Tempio della Sacra Reliquia del Dente",
  kandyGardens: "Giardini Botanici Reali, Peradeniya",
  kandyLake: "Passeggiata al Lago di Kandy e mercato locale",
  kandyLocation: "Tempio della Sacra Reliquia del Dente, Kandy",
  kandyDescription: "Capitale culturale con patrimonio sacro e giardini lussureggianti.",
  
  // Ella
  day4Title: "Ella",
  ellaTitle: "Ella",
  ellaStay: "Soggiorno accogliente a Ella",
  ellaTrain: "Viaggio panoramico in treno per Ella",
  ellaPeak: "Escursione al Picco di Adamo",
  ellaBridge: "Punto panoramico del Ponte delle Nove Arcate",
  ellaExplore: "Esplorazione delle vibrazioni del paese del tè in città",
  ellaLocation: "Treno panoramico vicino a Ella",
  ellaDescription: "Fuga collinare dal clima fresco con paesaggi montani mozzafiato.",
  
  // Galle
  day5Title: "Galle",
  galleTitle: "Galle",
  galleStay: "Hotel a Galle (o partenza tardiva)",
  galleTransfer: "Trasferimento a Galle",
  galleFort: "Esplorazione del Forte di Galle, patrimonio UNESCO",
  galleLighthouse: "Passeggiata al faro e alle mura",
  galleCafes: "Caffè, boutique e viste sul mare",
  galleContinue: "Continua per l'aeroporto o estendi il soggiorno in spiaggia",
  galleLocation: "Mura del Forte di Galle e faro",
  galleDescription: "Fascino costiero storico per concludere i tuoi highlights",
  
  // Colombo Tour
  threeDayColomboTitle: "Viaggio a Colombo - Sri Lanka",
  threeDayColomboSubtitle: "Vivi il meglio di Colombo con hotel di lusso, visite culturali, shopping e relax sull'oceano.",
  
  // Colombo
  dayOneTitle: "Arrivo",
  dayTwoTitle: "Tour della Città", 
  dayThreeTitle: "Partenza",
  
  // Day One Activities
  colomboArrival: "Arrivo all'Aeroporto Internazionale Bandaranaike",
  colomboTransfer: "Trasferimento in hotel e check-in",
  colomboFort: "Esplorazione dell'area del Forte di Colombo – edifici coloniali, mercati e shopping",
  colomboDinner: "Cena al ristorante dell'hotel e pernottamento.",
  
  // Day Two Activities
  colomboBreakfast: "Colazione in hotel",
  colomboTemple: "Visita al Tempio Gangaramaya e museo",
  colomboLunch: "Pranzo al ristorante locale",
  colomboMuseum: "Visita pomeridiana al Museo Nazionale e Parco Viharamahadevi",
  colomboOvernight: "Cena e pernottamento.",
  
  // Day Three Activities
  colomboRelax: "Relax al Galle Face Green e ammirazione dell'oceano",
  colomboShopping: "Shopping a Odel o Barefoot Gallery",
  colomboPrepare: "Preparazione per la partenza",
  colomboCheckout: "Check-out e trasferimento all'aeroporto.",
  
  // Hotels
  cinnamonGrand: "Cinnamon Grand Colombo",
  shangriLa: "Shangri-La Colombo",
  kingsbury: "The Kingsbury Colombo",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "Pacchetto Budget (Highlights dello Sri Lanka)",
  fiveDayBudgetPackSubtitle: "Highlights",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "Budget",
  fiveDayBudgetPackHighlights: "Highlights",
  fiveDayBudgetPackCulture: "Cultura",
  fiveDayBudgetPackHistory: "Storia",
  fiveDayBudgetPackNature: "Natura",
  fiveDayBudgetPackPrice: "Da US $650 Per Persona",
  moreInformation: "Maggiori Informazioni ➜",
  
  threeDayColomboCityTitle: "Esperienza Città di Colombo",
  threeDayColomboCitySubtitle: "Tour della Città",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "Tour della Città",
  threeDayColomboCityCulture: "Cultura",
  threeDayColomboCityShopping: "Shopping",
  threeDayColomboCityLuxury: "Hotel di Lusso",
  threeDayColomboCitySightseeing: "Sightseeing",
  threeDayColomboCityPrice: "Da US $350 Per Persona",
  
  familyTripTitle: "Viaggio Famiglia in Sri Lanka",
  familyTripSubtitle: "Pacchetto Famiglia",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "Fauna Selvatica",
  familyTripNature: "Natura",
  familyTripCulture: "Cultura",
  familyTripHistory: "Storia",
  familyTripPrice: "Da US $850 Per Persona",
  
  bestOfSriLankaTitle: "Il Meglio dello Sri Lanka",
  bestOfSriLankaSubtitle: "Completo",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "Spiaggia",
  bestOfSriLankaWildlife: "Fauna Selvatica",
  bestOfSriLankaNature: "Natura",
  bestOfSriLankaCulture: "Cultura",
  bestOfSriLankaPrice: "Da US $1250 Per Persona",
  
  romanticGetawayTitle: "Fuga Romantica in Sri Lanka",
  romanticGetawaySubtitle: "Pacchetto Romantico",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "Natura",
  romanticGetawayBeach: "Spiaggia",
  romanticGetawayWildlife: "Fauna Selvatica",
  romanticGetawayHistory: "Storia",
  romanticGetawayPrice: "Da US $1700 Per Persona",
  
  // Why Choose Us
  whyChooseUsTitle: "Perché Scegliere Noi",
  whyChooseUsSubtitle: "Molte persone ci hanno scelto come la loro azienda numero uno per la gestione delle destinazioni di viaggio, e anche voi ci sceglierete per i seguenti motivi.",
  
  whyChooseUsReason1: "Siamo una delle principali aziende di gestione delle destinazioni in Sri Lanka.",
  whyChooseUsReason2: "Siamo uno dei principali tour operator in Sri Lanka.",
  whyChooseUsReason3: "Offriamo un pacchetto di viaggio completo a viaggiatori e agenti di viaggio.",
  whyChooseUsReason4: "Abbiamo un team appassionato e professionale di 40 rappresentanti con una vasta conoscenza del turismo dello Sri Lanka.",
  whyChooseUsReason5: "Siamo uno dei principali agenti di viaggio in Sri Lanka.",
  whyChooseUsReason6: "Forniamo tour personalizzati e specializzati ai nostri clienti.",
  whyChooseUsReason7: "Siamo un agente di viaggio leader in Sri Lanka che fornisce tour e pacchetti vacanze a destinazioni esotiche.",
  whyChooseUsReason8: "Offriamo supporto clienti 24/7 ai nostri clienti.",
  
  readMore: "LEGGI DI PIÙ",
  
  // How It Works
  howItWorksTitle: "COME FUNZIONA?",
  
  // Common UI elements
  days: "Giorni",
  from: "Da",
  perPerson: "Per Persona",
  
  step1Title: "1. Richiedi Ora",
  step1Time: "5 Minuti",
  step1FillingForm: "Compilazione del modulo web",
  step1WebChat: "Chat web live",
  step1Email: "Email",
  step1Call: "Chiamaci",
  
  step2Title: "2. Connetti con l'Esperto di Viaggio",
  step2Time: "30 Minuti",
  step2Discuss: "Discuti le tue esigenze",
  step2FreeAdvice: "Consulenza di viaggio gratuita",
  step2Support: "Supporto 24/7",
  
  step3Title: "3. Ricevi 3 Opzioni di Viaggio",
  step3Discuss: "Discuti le modifiche",
  step3Finalise: "Finalizza il piano di viaggio",
  step3Pay: "Paga il 10%",
  
  step4Title: "4. Ricevi la Conferma del Tuo Viaggio",
  step4FillingForm: "Compilazione del modulo web",
  step4Satisfaction: "Soddisfazione garantita al 100%",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "Circuito Completo dello Sri Lanka",
  completeSriLankaSubtitle: "Completo",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "Completo",
  completeSriLankaHighlights: "Punti Salienti",
  completeSriLankaCulture: "Cultura",
  completeSriLankaHistory: "Storia",
  completeSriLankaNature: "Natura",
  completeSriLankaBeach: "Spiaggia",
  completeSriLankaPrice: "Da US $1850 Per Persona",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "Circuito Completo dello Sri Lanka",
  completeSriLankaCircuitSubtitle: "Sperimenta la bellezza completa dello Sri Lanka con questo viaggio completo che copre tutte le destinazioni principali.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "Anuradhapura",
  ancientCityStay: "Hotel ad Anuradhapura",
  ancientCityTransfer: "Trasferimento ad Anuradhapura",
  ancientCityExplore: "Esplora le rovine antiche e gli stupa",
  ancientCityTemple: "Visita l'albero Sri Maha Bodhi",
  ancientCityMuseum: "Visita il Museo Archeologico",
  ancientCityLocation: "Città Antica di Anuradhapura",
  ancientCityDescription: "Scopri l'antica capitale dello Sri Lanka e il sito del patrimonio mondiale dell'UNESCO.",
  
  // Nuwara Eliya
  day5Title: "Nuwara Eliya",
  nuwaraEliyaTitle: "Nuwara Eliya",
  nuwaraEliyaStay: "Hotel a Nuwara Eliya",
  nuwaraEliyaTransfer: "Trasferimento a Nuwara Eliya",
  nuwaraEliyaTea: "Tour delle piantagioni di tè e della fabbrica",
  nuwaraEliyaLake: "Giro in barca sul Lago Gregory",
  nuwaraEliyaExplore: "Esplora la Piccola Inghilterra",
  nuwaraEliyaLocation: "Paese del Tè di Nuwara Eliya",
  nuwaraEliyaDescription: "Sperimenta il clima fresco e il fascino del paese del tè della Piccola Inghilterra.",
  
  // Ella (Second Day)
  day6Title: "Ella",
  day7Title: "Ella Estesa",
  ellaWaterfall: "Visita le Cascate di Ravana",
  ellaTea: "Tour delle piantagioni di tè",
  ellaRelax: "Rilassati e goditi le viste montane",
  ellaLocal: "Esperienza del villaggio locale",
  ellaDay2Description: "Secondo giorno a Ella per esplorare cascate e paese del tè.",
  
  // Mirissa
  day8Title: "Mirissa",
  mirissaTitle: "Mirissa",
  mirissaStay: "Resort sulla spiaggia a Mirissa",
  mirissaTransfer: "Trasferimento a Mirissa",
  mirissaBeach: "Rilassati sulla spiaggia di Mirissa",
  mirissaWhale: "Tour di avvistamento balene (stagionale)",
  mirissaRelax: "Rilassamento sulla spiaggia e tramonto",
  mirissaLocation: "Spiaggia di Mirissa",
  mirissaDescription: "Goditi le belle spiagge e le opportunità di avvistamento balene.",
  
  // Mirissa (Second Day)
  day9Title: "Mirissa Estesa",
  mirissaSnorkel: "Snorkeling e sport acquatici",
  mirissaDiving: "Immersioni subacquee (opzionale)",
  mirissaSunset: "Passeggiata sulla spiaggia al tramonto",
  mirissaDay2Description: "Secondo giorno a Mirissa per attività acquatiche e relax sulla spiaggia.",
  
  // Galle
  day10Title: "Galle",
  
  // Galle (Second Day)
  day11Title: "Galle Estesa",
  galleShopping: "Shopping nel Forte di Galle",
  galleMuseum: "Visita il Museo Marittimo di Galle",
  galleBeach: "Tempo sulla spiaggia a Unawatuna",
  galleDining: "Cena nei ristoranti del forte",
  galleDay2Description: "Secondo giorno a Galle per esplorare di più il forte storico.",
  
  // Bentota
  day12Title: "Bentota",
  bentotaTitle: "Bentota",
  bentotaStay: "Resort a Bentota",
  bentotaTransfer: "Trasferimento a Bentota",
  bentotaRiver: "Safari sul fiume Bentota",
  bentotaBeach: "Attività sulla spiaggia",
  bentotaSpa: "Trattamenti spa e benessere",
  bentotaLocation: "Resort sulla spiaggia di Bentota",
  bentotaDescription: "Rilassati nel bellissimo resort sulla spiaggia con attività fluviali.",
  
  // Colombo
  day13Title: "Colombo",
  colomboTitle: "Colombo",
  colomboStay: "Hotel a Colombo",
  colomboTransfer: "Trasferimento a Colombo",
  colomboFort: "Esplora il Forte di Colombo",
  colomboTemple: "Visita il Tempio di Gangaramaya",
  colomboShopping: "Shopping a Odel e Barefoot",
  colomboLocation: "Città di Colombo",
  colomboDescription: "Esplora le attrazioni della capitale e lo shopping.",
  
  // Departure
  day14Title: "Partenza",
  departureTitle: "Partenza",
  departureStay: "Hotel aeroporto o partenza",
  departureBreakfast: "Ultima colazione",
  departureShopping: "Shopping dell'ultimo minuto",
  departureTransfer: "Trasferimento all'aeroporto",
  departureAirport: "Partenza dall'Aeroporto Internazionale di Bandaranaike",
  departureLocation: "Aeroporto Internazionale di Bandaranaike",
  departureDescription: "Ultimo giorno con trasferimento aeroporto e partenza.",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "Tour della Fauna Selvatica e del Patrimonio Culturale",
  wildlifeCulturalCircuitSubtitle: "Sperimenta la fauna selvatica, le città antiche e il patrimonio culturale dello Sri Lanka in questo viaggio completo.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "Udawalawe",
  udawalaweStay: "Lodge safari a Udawalawe",
  udawalaweTransfer: "Trasferimento a Udawalawe",
  udawalaweSafari: "Safari nel Parco Nazionale di Udawalawe",
  udawalaweElephants: "Osservazione degli elefanti e fotografia",
  udawalaweBirds: "Tour di birdwatching",
  udawalaweLocation: "Parco Nazionale di Udawalawe",
  udawalaweDescription: "Sperimenta la fauna selvatica dello Sri Lanka con elefanti, uccelli e altri animali nel loro habitat naturale.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "Ella",
  ellaWildlifeStay: "Hotel a Ella",
  ellaWildlifeTransfer: "Trasferimento a Ella",
  ellaWildlifeTrain: "Viaggio panoramico in treno a Ella",
  ellaWildlifePeak: "Escursione al Picco di Adamo",
  ellaWildlifeBridge: "Punto panoramico del Ponte delle Nove Arcate",
  ellaWildlifeLocation: "Stazione di montagna di Ella",
  ellaWildlifeDescription: "Esplora la bella regione montuosa con viste panoramiche sulle montagne e piantagioni di tè.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "Nuwara Eliya",
  nuwaraEliyaWildlifeStay: "Hotel a Nuwara Eliya",
  nuwaraEliyaWildlifeTransfer: "Trasferimento a Nuwara Eliya",
  nuwaraEliyaWildlifeTea: "Tour della piantagione di tè e della fabbrica",
  nuwaraEliyaWildlifeLake: "Giro in barca sul Lago Gregory",
  nuwaraEliyaWildlifeExplore: "Esplora la Piccola Inghilterra",
  nuwaraEliyaWildlifeLocation: "Paese del tè di Nuwara Eliya",
  nuwaraEliyaWildlifeDescription: "Sperimenta il clima fresco e il fascino del paese del tè della Piccola Inghilterra.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "Kandy",
  kandyWildlifeStay: "Hotel a Kandy",
  kandyWildlifeTransfer: "Trasferimento a Kandy",
  kandyWildlifeTemple: "Tempio della Sacra Reliquia del Dente",
  kandyWildlifeGardens: "Giardini Botanici Reali",
  kandyWildlifeLake: "Passeggiata sul Lago di Kandy",
  kandyWildlifeLocation: "Tempio della Sacra Reliquia del Dente",
  kandyWildlifeDescription: "Capitale culturale con patrimonio sacro e giardini lussureggianti.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "Sigiriya",
  sigiriyaWildlifeStay: "Hotel a Sigiriya",
  sigiriyaWildlifeTransfer: "Trasferimento a Sigiriya",
  sigiriyaWildlifeClimb: "Scalata della Fortezza Rocciosa di Sigiriya",
  sigiriyaWildlifeExplore: "Esplorazione dei giardini acquatici e degli affreschi",
  sigiriyaWildlifeVillage: "Esperienza del villaggio o giro in bicicletta (opzionale)",
  sigiriyaWildlifeLocation: "Fortezza Rocciosa di Sigiriya",
  sigiriyaWildlifeDescription: "Iconico sito del Patrimonio Mondiale UNESCO con viste panoramiche.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "Anuradhapura",
  anuradhapuraWildlifeStay: "Hotel a Anuradhapura",
  anuradhapuraWildlifeTransfer: "Trasferimento ad Anuradhapura",
  anuradhapuraWildlifeExplore: "Esplora le rovine antiche e gli stupa",
  anuradhapuraWildlifeTemple: "Visita l'albero Sri Maha Bodhi",
  anuradhapuraWildlifeMuseum: "Visita il Museo Archeologico",
  anuradhapuraWildlifeLocation: "Città antica di Anuradhapura",
  anuradhapuraWildlifeDescription: "Scopri l'antica capitale dello Sri Lanka e il sito del Patrimonio Mondiale UNESCO.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "Polonnaruwa",
  polonnaruwaStay: "Hotel a Polonnaruwa",
  polonnaruwaTransfer: "Trasferimento a Polonnaruwa",
  polonnaruwaExplore: "Esplorazione delle rovine antiche",
  polonnaruwaGalVihara: "Visita a Gal Vihara",
  polonnaruwaMuseum: "Visita al Museo di Polonnaruwa",
  polonnaruwaLocation: "Città antica di Polonnaruwa",
  polonnaruwaDescription: "Esplora l'antica capitale con rovine ben conservate e sculture.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "Trincomalee",
  trincomaleeStay: "Hotel a Trincomalee",
  trincomaleeTransfer: "Trasferimento a Trincomalee",
  trincomaleeBeach: "Relax sulla spiaggia di Nilaveli",
  trincomaleeWhale: "Tour di avvistamento balene (stagionale)",
  trincomaleeFort: "Esplorazione del Forte Frederick",
  trincomaleeLocation: "Spiaggia di Nilaveli, Trincomalee",
  trincomaleeDescription: "Goditi le belle spiagge e le opportunità di avvistamento balene.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "Colombo",
  colomboWildlifeStay: "Hotel a Colombo",
  colomboWildlifeTransfer: "Trasferimento a Colombo",
  colomboWildlifeFort: "Esplorazione del Forte di Colombo",
  colomboWildlifeTemple: "Visita al Tempio di Gangaramaya",
  colomboWildlifeShopping: "Shopping a Odel e Beirafoot Gallery",
  colomboWildlifeLocation: "Città di Colombo",
  colomboWildlifeDescription: "Esplora le attrazioni della capitale e lo shopping.",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "Tour della Fauna Selvatica e del Patrimonio Culturale",
  wildlifeCulturalType: "Fauna Selvatica e Cultura",
  wildlifeCulturalHighlights: "Attrazioni",
  wildlifeCulturalWildlife: "Fauna Selvatica",
  wildlifeCulturalCulture: "Cultura",
  wildlifeCulturalHistory: "Storia",
  wildlifeCulturalNature: "Natura",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "Tour della Regione Montuosa e delle Spiagge",
  hillCountryBeachType: "Regione Montuosa e Spiagge",
  hillCountryBeachHighlights: "Attrazioni",
  hillCountryBeachNature: "Natura",
  hillCountryBeachBeach: "Spiaggia",
  hillCountryBeachCulture: "Cultura",
  hillCountryBeachAdventure: "Avventura",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "Tour del Triangolo Culturale e delle Spiagge",
  culturalTriangleBeachType: "Triangolo Culturale e Spiagge",
  culturalTriangleBeachHighlights: "Attrazioni",
  culturalTriangleBeachCulture: "Cultura",
  culturalTriangleBeachHistory: "Storia",
  culturalTriangleBeachBeach: "Spiaggia",
  culturalTriangleBeachRelaxation: "Relax",
  
  // Package 1
  package1Title: "Pacchetto 1 - Sri Lanka",
  package1Duration: "4 notti 5 giorni",
  package1Charges: "Solo costi di hotel e trasporto",
  package1Hotel: "Hotel 4 stelle include letto, cena e colazione",
  package1Price: "Starting From: USD 780\nper 2 persons",
  package1Day1: "Giorno 1",
  package1Day1Activity1: "Pinnawala",
  package1Day1Activity2: "Kandy (danza di Kandy)",
  package1Day2: "Giorno 2",
  package1Day2Activity1: "Nelligala",
  package1Day2Activity2: "Tempio di Kandy",
  package1Day3: "Giorno 3",
  package1Day3Activity1: "Gadaladeniya, Ambakke",
  package1Day3Activity2: "Giardino di Peradeniya",
  package1Day4: "Giorno 4",
  package1Day4Activity1: "Museo delle cere Kandy",
  package1Day4Activity2: "Acquisti di gemme, spezie e batik",
  package1Activities: "Attività",
  
  // Package 2
  package2Title: "Pacchetto 2 - Sri Lanka",
  package2Duration: "4 notti 5 giorni",
  package2Charges: "Solo costi di hotel e trasporto",
  package2Hotel: "Hotel 4 stelle include letto, cena e colazione",
  package2Price: "Starting From: USD 1130\nper 2 persons",
  package2Day1: "Giorno 1",
  package2Day1Activity1: "Pinnawala",
  package2Day1Activity2: "Tempio di Kandy",
  package2Day1Activity3: "Danza di Kandy",
  package2Day2: "Giorno 2",
  package2Day2Activity1: "Acquisti di gemme, spezie e batik",
  package2Day2Activity2: "Giardino di Peradeniya",
  package2Day2Activity3: "Nelligala",
  package2Day3: "Giorno 3",
  package2Day3Activity1: "Nuwara Eliya",
  package2Day3Activity2: "Parco Gregory",
  package2Day4: "Giorno 4",
  package2Day4Activity1: "Fattoria Ambewela",
  package2Activities: "Attività",
  
  // Package 3
  package3Title: "Pacchetto 3 - Sri Lanka",
  package3Duration: "4 notti 5 giorni",
  package3Charges: "Solo costi di hotel e trasporto",
  package3Hotel: "Hotel 4 stelle include letto, cena e colazione",
  package3Price: "Starting From: USD 895\nper 2 persons",
  package3Day1: "Giorno 1",
  package3Day1Activity1: "Pinnawala",
  package3Day1Activity2: "Tempio di Kandy",
  package3Day1Activity3: "Danza di Kandy",
  package3Day2: "Giorno 2",
  package3Day2Activity1: "Giardino di Peradeniya",
  package3Day2Activity2: "Nelligala",
  package3Day2Activity3: "Acquisti di gemme, spezie e batik",
  package3Day3: "Giorno 3",
  package3Day3Activity1: "Sigiriya",
  package3Day4: "Giorno 4",
  package3Day4Activity1: "Tempio di Dambulla",
  package3Day4Activity2: "Tempio del villaggio di Dambulla",
  package3Activities: "Attività",
  
  
  // Package tags
  hotel: "Hotel",
  transport: "Trasporto",
  cultural: "Culturale",
  shopping: "Shopping",
  hillCountry: "Paese delle Colline",
  teaPlantations: "Piantagioni di Tè",
  sigiriya: "Sigiriya",
  heritageSites: "Siti Patrimonio",
  safari: "Safari",
  wildlife: "Fauna Selvatica",
  
  // Package titles (short version for cards)
  package1: "Pacchetto 1",
  package2: "Pacchetto 2",
  package3: "Pacchetto 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Starting From: USD 990\nper 2 persons",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Starting From: USD 1390\nper 2 persons",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
